import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Input,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";
import { addAdsViews, getAds } from "store/actions/getAdsAction";

const AdsSection = () => {
  const dispatch = useDispatch();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isPreviewModal, setIsPreviewModal] = useState(false);
  const [checkWarning, setCheckWarning] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [siteUrl, setSiteUrl] = useState("");
  const [collectionId, setCollectionId] = useState("");
  const [selectedAd, setSelectedAd] = useState(null);

  const { uid, user } = useSelector((state) => state.auth);
  const { ads, lastDocument, hasMoreDocument } = useSelector(
    (state) => state.ads
  );

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggle = () => {
    setIsOpenModal(!isOpenModal);
    setCheckWarning(false);
  };

  const togglePreview = () => {
    setIsPreviewModal(!isPreviewModal);
    setSelectedAd(null);
  };

  const handleShowAds = () => {
    window.open(siteUrl, "_blank", "noopener,noreferrer");
    dispatch(
      addAdsViews(collectionId, {
        fan_id: uid,
        fan_name: user?.name,
        fan_email: user?.email,
      })
    );
    toggle();
  };

  useEffect(() => {
    if (user?.showAds) {
      setDataLoader(true);
      dispatch(
        getAds(user.showAds, lastDocument, () => {
          setDataLoader(false);
        })
      );
    }
  }, [user?.showAds]);

  const loadMore = () => {
    setBtnLoader(true);
    dispatch(
      getAds(user.showAds, lastDocument, () => {
        setBtnLoader(false);
      })
    );
  };

  return (
    <>
      <h1 className="text-center">Great DEALS!</h1>
      {dataLoader ? (
        <div className="text-center">
          <Spinner color="primary" />
        </div>
      ) : ads.length > 0 ? (
        <>
          {ads.map((item, index) => (
            <div key={index} className="mb-4 px-2">
              <div className="text-center">
                {item.bidType === "image" ? (
                  <img
                    src={item.imageUrl}
                    alt=""
                    className="img-fluid rounded"
                  />
                ) : (
                  <video className="w-100 rounded" height={190} controls>
                    <source src={item.videoUrl} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
              </div>

              <h5 className="text-center mt-2">{item.description}</h5>

              <div className="text-center mt-2">
                {isMobile ? (
                  <>
                    <Button
                      color="primary"
                      size="sm"
                      className="mx-1"
                      onClick={() => {
                        setSelectedAd(item);
                        setIsPreviewModal(true);
                      }}
                    >
                      See Ad
                    </Button>
                    <Button
                      color="primary"
                      size="sm"
                      className="mx-1"
                      onClick={() => {
                        setSiteUrl(item.website);
                        setCollectionId(item.id);
                        toggle();
                      }}
                    >
                      Visit Site
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => {
                        setSiteUrl(item.website);
                        setCollectionId(item.id);
                        toggle();
                      }}
                    >
                      Visit Site
                    </Button>
                  </>
                )}
              </div>

              <hr />
            </div>
          ))}

          {ads.length > 19 && (
            <div className="text-center">
              <Button
                color="primary"
                size="sm"
                onClick={loadMore}
                disabled={!hasMoreDocument}
              >
                {btnLoader ? <Spinner size="sm" /> : "Load More"}
              </Button>
            </div>
          )}
        </>
      ) : (
        <h2 className="text-center">No Ads Found</h2>
      )}

      <Modal
        isOpen={isOpenModal}
        toggle={toggle}
        className="modal-dialog modal-dialog-centered"
      >
        <ModalHeader>You are about to leave FansHelpPlayers:</ModalHeader>
        <ModalBody>
          <h5>
            Do not give your credit card information to a vendor you do not know
            and trust.
          </h5>
          <Input
            type="checkbox"
            checked={checkWarning}
            onChange={(e) => setCheckWarning(e.target.checked)}
          />{" "}
          I will check reviews before I buy. I will not hold FansHelpPlayers,
          LLC responsible in any way for my purchase decisions.
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={toggle}>
            Cancel
          </Button>
          <Button
            disabled={!checkWarning}
            color="primary"
            onClick={handleShowAds}
          >
            Ok
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={isPreviewModal}
        toggle={togglePreview}
        className="modal-dialog modal-dialog-centered"
      >
        <ModalHeader toggle={togglePreview}>Ad Preview</ModalHeader>
        <ModalBody>
          <div className="text-center d-flex flex-column align-items-center">
            {selectedAd?.bidType === "image" ? (
              <img
                src={selectedAd.imageUrl}
                alt="Ad"
                className="img-fluid rounded"
                style={{ maxWidth: "100%" }}
              />
            ) : (
              <video width="100%" controls className="rounded" autoPlay>
                <source src={selectedAd?.videoUrl} type="video/mp4" />
              </video>
            )}
            <h4 className="mt-3">{selectedAd?.description}</h4>
          </div>
        </ModalBody>

        <ModalFooter>
          <Button color="danger" onClick={togglePreview}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AdsSection;
